<template>
  <master-layout smallTitle="Notifiche" bigTitle="Notifications">
    <div class="p-4">
      <!-- Mostrar un loader mientras se cargan las notificaciones -->
      <div v-if="loadingNotificationList" class="loader">Loading...</div>
      
      <div v-for="notification in notifications" :key="notification.id" class="card">
        <div class="header">
          <span class="date">{{ notification.date }}</span>
          <h3 class="text-md font-semibold">{{ notification.title }}</h3>
        </div>
      </div>
    </div>
  </master-layout>
</template>

<script>
import MasterLayout from "../components/MasterLayout.vue";
import { ref, onMounted } from "vue";
import ApiService from "../common/service.api";

export default {
  name: "NotificationsView",
  components: {
    MasterLayout,
  },
  setup() {
    const notifications = ref([]); 
    const loadingNotificationList = ref(false); 

  
    function getNotificationList() {
      loadingNotificationList.value = true;
      ApiService.get("Notification/GetUserNotification")
        .then((res) => {
          notifications.value = res.data;
          console.log('notifiacion', notifications.value)
        })
        .finally(() => {
          loadingNotificationList.value = false; 
        });
    }
    onMounted(() => {
      getNotificationList();
    });

    return {
      notifications,
      loadingNotificationList,
    };
  },
};
</script>
  
  <style scoped>
  .card {
    background: #fff;
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 10px;
    height: 4.5rem; 
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  .header {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  
  .date {
    font-size: 0.875rem; 
    color: #6b7280; 
    margin-top: 8px; 
  }
  </style>
  